interface PrescriptionStatusCount {
  expired: number;
  inProcess: number;
  completed: number;
}

interface ActionStatusCount {
  notStarted: number;
  expired: number;
  inProcess: number;
  current: number;
}

export const transformPrescriptionsToChartData = (prescriptions: any, currentFilters: any, locationMapping: any[]) => {
  const result: { [key: string]: PrescriptionStatusCount } = {};
  const selectedStatuses = currentFilters.status?.selected || [];

  const locationMappingObject: { [key: string]: string } = {};
  locationMapping.forEach((location) => {
    locationMappingObject[location.Title] = location.Code;
  });

  locationMapping.forEach((location) => {
    result[location.Code] = {
      expired: 0,
      inProcess: 0,
      completed: 0,
    };
  });

  prescriptions.forEach((prescription: any) => {
    if (selectedStatuses.length > 0 && !selectedStatuses.includes(prescription.status.name)) {
      return;
    }

    const locationName = prescription.location?.name;
    if (!locationName) return;

    const locationCode = locationMappingObject[locationName];
    if (!locationCode) return;

    if (prescription.status.name === 'Просрочено') {
      result[locationCode].expired += 1;
    } else if (prescription.status.name === 'В процессе') {
      result[locationCode].inProcess += 1;
    } else if (prescription.status.name === 'Выполнено') {
      result[locationCode].completed += 1;
    }
  });

  return result;
};

export const transformActionsToChartData = (prescriptions: any, currentFilters: any, locationMapping: any[]) => {
  const result: { [key: string]: ActionStatusCount } = {};
  const selectedStatuses = currentFilters.status?.selected || [];

  const locationMappingObject: { [key: string]: string } = {};
  locationMapping.forEach((location) => {
    locationMappingObject[location.Title] = location.Code;
  });

  locationMapping.forEach((location) => {
    result[location.Code] = {
      notStarted: 0,
      expired: 0,
      inProcess: 0,
      current: 0,
    };
  });

  prescriptions.forEach((prescription: any) => {
    if (selectedStatuses.length > 0 && !selectedStatuses.includes(prescription.status.name)) {
      return;
    }
    const locationName = prescription.location?.name;
    if (!locationName) return;

    const locationCode = locationMappingObject[locationName];
    if (!locationCode) return;

    prescription.violations.forEach((violation: any) => {
      violation.actions.forEach((action: any) => {
        const status = action.Status?.ID || action.Status?.$1q_1;

        if (status === 227) {
          result[locationCode].notStarted += 1;
        } else if (status === 229) {
          result[locationCode].expired += 1;
        } else if (status === 231 || status === 230) {
          result[locationCode].current += 1;
        } else {
          result[locationCode].inProcess += 1;
        }
      });
    });
  });

  return result;
};

// export const transformActionsToChartData = (prescriptions: any, currentFilters: any, locationMapping: any[]) => {
//   const result: { [key: string]: ActionStatusCount } = {};
//   const selectedStatuses = currentFilters.status?.selected || [];

//   const locationMappingObject: { [key: string]: string } = {};
//   locationMapping.forEach((location) => {
//     locationMappingObject[location.Title] = location.Code;
//   });

//   locationMapping.forEach((location) => {
//     result[location.Code] = {
//       notStarted: 0,
//       expired: 0,
//       inProcess: 0,
//       current: 0,
//     };
//   });

//   prescriptions.forEach((prescription: any) => {
//     if (selectedStatuses.length > 0 && !selectedStatuses.includes(prescription.status.name)) {
//       return;
//     }

//     const locationName = prescription.location?.name;
//     if (!locationName) return;

//     const locationCode = locationMappingObject[locationName];
//     if (!locationCode) return;

//     if (prescription.actionStatus === 'Не начато') {
//       result[locationCode].notStarted += 1;
//     } else if (prescription.actionStatus === 'Просрочено') {
//       result[locationCode].expired += 1;
//     } else if (prescription.actionStatus === 'В процессе') {
//       result[locationCode].inProcess += 1;
//     } else if (prescription.actionStatus === 'Закрыто') {
//       result[locationCode].current += 1;
//     }
//   });

//   return result;
// };
